export default function PatientHeaderProfile({ patient }) {
  return (
    <div className="flex items-center gap-4 mb-6 pl-5">
      <div className="w-16 h-16 rounded-full bg-gray-800 flex items-center justify-center">
        <svg
          className="w-10 h-10 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            fillRule="evenodd"
            d="M12 20a7.966 7.966 0 0 1-5.002-1.756v-.683c0-1.794 1.492-3.25 3.333-3.25h3.334c1.84 0 3.333 1.456 3.333 3.25v.683A7.966 7.966 0 0 1 12 20ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 5.5-4.44 9.963-9.932 10H12C6.438 21.962 2 17.5 2 12Zm10-5c-1.84 0-3.333 1.455-3.333 3.25S10.159 13.5 12 13.5c1.84 0 3.333-1.455 3.333-3.25S13.841 7 12 7Z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div className="text-xl font-medium text-gray-800">
        {patient.first_name} {patient.last_name}
      </div>
    </div>
  );
}
